// ─── Types ────────────────────────────────────────────────────────────────────

export type Rarity = 'Mythic' | 'Legendary' | 'Trophy' | string;

interface RarityBadgeProps {
  rarity: Rarity;
  className?: string;
}

// ─── Style map ────────────────────────────────────────────────────────────────

const RARITY_STYLES: Record<string, string> = {
  Mythic: 'bg-primary/10 text-primary border-primary/30',
  Legendary: 'bg-secondary/10 text-secondary border-secondary/30',
  Trophy: 'bg-iron-700 text-iron-300 border-iron-600',
};

const FALLBACK_STYLE = 'bg-iron-800 text-iron-400 border-iron-700';

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Displays the rarity tier of an auction item as a compact styled badge.
 * Supports: Mythic (red), Legendary (gold), Trophy (steel), and custom strings.
 */
export function RarityBadge({ rarity, className = '' }: RarityBadgeProps) {
  const style = RARITY_STYLES[rarity] ?? FALLBACK_STYLE;
  return (
    <span
      className={`text-[9px] tracking-[0.3em] uppercase font-bold border px-2 py-0.5 ${style} ${className}`}
    >
      {rarity}
    </span>
  );
}
